function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const MediaListIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.5v3c0 .8-.7 1.5-1.5 1.5h-5C.7 25 0 24.3 0 23.5v-3c0-.8.7-1.5 1.5-1.5h5c.8 0 1.5.7 1.5 1.5zm0-8v3c0 .8-.7 1.5-1.5 1.5h-5C.7 17 0 16.3 0 15.5v-3c0-.8.7-1.5 1.5-1.5h5c.8 0 1.5.7 1.5 1.5zm20 8v3c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5v-3c0-.8.7-1.5 1.5-1.5h15c.8 0 1.5.7 1.5 1.5zM8 4.5v3C8 8.3 7.3 9 6.5 9h-5C.7 9 0 8.3 0 7.5v-3C0 3.7.7 3 1.5 3h5C7.3 3 8 3.7 8 4.5zm20 8v3c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5v-3c0-.8.7-1.5 1.5-1.5h15c.8 0 1.5.7 1.5 1.5zm0-8v3c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5v-3c0-.8.7-1.5 1.5-1.5h15c.8 0 1.5.7 1.5 1.5z"
  }));
};
export default MediaListIcon;